module.exports = __webpack_public_path__ + "img/af8101fa8380fd27a4c5a2a844b11cdb.svg";